import * as actionTypes from './../Global_action.types';
import * as api from './../global_api_services/Login.api';
import { jwtDecode } from 'jwt-decode';


export const loginRequest = (userData) => ({
  type: actionTypes.LOGIN_REQUEST,
  payload: userData,
});

export const loginSuccess = (user) => ({
  type: actionTypes.LOGIN_SUCCESS,
  payload: user,
});

export const loginFailure = (error) => ({
  type: actionTypes.LOGIN_FAILURE,
  payload: error,
});

export const setUser = (user) => ({
  type: actionTypes.SET_USER,
  payload: user,
});
export const loadUserFromToken = () => {
  return (dispatch) => {
    const token = localStorage.getItem('token');
    if (token) {
      const user = jwtDecode(token);
      dispatch(setUser(user));
    }
  };
};
export const login = (userData) => {
  return async (dispatch) => {
    dispatch(loginRequest(userData));
    try {
      const response = await api.loginUser(userData);
      if (response.status === 200) {
        // sessionStorage.setItem('user', JSON.stringify(response.data.user)); // Save user data to session storage
        // localStorage.setItem('token', response.token); // Save the access token
        dispatch(loginSuccess(response.data.user));
        return { success: true, token: response.token };
      } else {
        dispatch(loginFailure(response.message || 'Login failed'));
        return { success: false, message: response.message };
      }
    } catch (error) {
      dispatch(loginFailure(error.message || 'An error occurred'));
      return { success: false, message: error.message };
    }
  };
};

export const verifyOtpRequest = (otpData) => ({
  type: actionTypes.VERIFY_OTP_REQUEST,
  payload: otpData,
});

export const verifyOtpSuccess = () => ({
  type: actionTypes.VERIFY_OTP_SUCCESS,
});

export const verifyOtpFailure = (error) => ({
  type: actionTypes.VERIFY_OTP_FAILURE,
  payload: error,
});

export const verifyOtp = (otpData) => {
  return async (dispatch) => {
    dispatch(verifyOtpRequest(otpData));
    try {
      const response = await api.verifyOtp(otpData);
      console.log("response action ",response);
      
      if (response.status === 200) {
        sessionStorage.setItem('user', JSON.stringify(response.data.user)); // Save user data to session storage
        localStorage.setItem('token', response.token); // Save the access token
        dispatch(verifyOtpSuccess());
        return { success: true };
      } else {
        return { success: false, message: response.message };
      }
    } catch (error) {      
      dispatch(verifyOtpFailure(error.message || 'An error occurred'));
      return { success: false, message: error };
    }
  };
};



export const forgotPasswordRequest = (userData) => ({
  type: actionTypes.FORGOT_PASSWORD_REQUEST,
  payload: userData,
});

export const forgotPasswordSuccess = () => ({
  type: actionTypes.FORGOT_PASSWORD_SUCCESS,
});

export const forgotPasswordFailure = (error) => ({
  type: actionTypes.FORGOT_PASSWORD_FAILURE,
  payload: error,
});

export const forgotPassword = (userData) => {
  return async (dispatch) => {
    dispatch(forgotPasswordRequest(userData));
    try {
      const response = await api.forgotPassword(userData);
      if (response.status === 200) {
        dispatch(forgotPasswordSuccess());
        return { success: true };
      } else {
        return { success: false, message: response.message };
      }

    } catch (error) {
      dispatch(forgotPasswordFailure(error));
      return { success: false, message: error.message || 'An error occurred' };
    }
  };
};

export const resetPasswordRequest = (userData) => ({
  type: actionTypes.RESET_PASSWORD_REQUEST,
  payload: userData,
});

export const resetPasswordSuccess = () => ({
  type: actionTypes.RESET_PASSWORD_SUCCESS,
});

export const resetPasswordFailure = (error) => ({
  type: actionTypes.RESET_PASSWORD_FAILURE,
  payload: error,
});

export const resetPassword = (userData) => {
  return async (dispatch) => {
    dispatch(resetPasswordRequest(userData));
    try {
      const response = await api.resetPassword(userData);
      if (response.status === 200) {
        dispatch(resetPasswordSuccess());
        return { success: true };
      } else {
        return { success: false, message: response.message };
      }
    } catch (error) {
      dispatch(resetPasswordFailure(error));
      return { success: false, message: error.message };
    }
  };
};


export const UserRequest = (userInputs) => ({
  type: actionTypes.USER_CREATE_REQUEST,
  payload: userInputs,
});
export const UserSuccess = (user) => ({
  type: actionTypes.USER_CREATE_SUCCESS,
  payload: user,
});

export const UserFailure = (error) => ({
  type: actionTypes.USER_CREATE_FAILURE,
  payload: error,
});


export const createUser = (userInputs) => {
  return async (dispatch) => {
    dispatch(UserRequest(userInputs));
    try {
      const response = await api.createUsers(userInputs);      
      if (response.status === 200) {
        dispatch(UserSuccess(response.data.user));
        return { success: true, message: response.data.message };
      } else {
        dispatch(UserFailure(response.message || 'state input failed'));
        return { success: false, message: response.error };
      }
    } catch (error) {
      dispatch(UserFailure(error.message || 'An error occurred'));
      return { success: false, message: error.message };
    }
  };
};


export const getUserRequest = () => ({
  type: actionTypes.USER_GET_REQUEST,
});

export const getUserSuccess = (user) => ({
  type: actionTypes.USER_GET_SUCCESS,
  payload: user,
});

export const getUserFailure = (error) => ({
  type: actionTypes.USER_GET_FAILURE,
  payload: error,
});

export const getUser = (CompanyID) => {
    if (!CompanyID || CompanyID.length === 0) {

    const user = JSON.parse(sessionStorage.getItem('user'));
    if(user.company_code){
        CompanyID = user.company_code;
    }
      }
    return async (dispatch) => {
      dispatch(getUserRequest());
      try {
        const user = await api.fetchUser(CompanyID);
        dispatch(getUserSuccess(user));
        return { success: true, data: user };
      } catch (error) {
        dispatch(getUserFailure(error));
        return { success: false, message: error };
      }
    };
  };

export const updateUserRequest = (id, userData) => ({
  type: actionTypes.USER_UPDATE_REQUEST,
  payload: { id, userData },
});

export const updateUserSuccess = (message) => ({
  type: actionTypes.USER_UPDATE_SUCCESS,
  payload: message,
});

export const updateUserFailure = (error) => ({
  type: actionTypes.USER_UPDATE_FAILURE,
  payload: error,
});

export const updateUserById = (id, stateData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    stateData.updated_by = user.user_name;
    dispatch(updateUserRequest(id, stateData));
    try {
      const response = await api.updateUser(id, stateData);
      dispatch(updateUserSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateUserFailure(error));
      return { success: false, message: error };
    }
  };
};

export const deleteUserRequest = (id) => ({
  type: actionTypes.USER_DELETE_REQUEST,
  payload: id,
});

export const deleteUserSuccess = (message) => ({
  type: actionTypes.USER_DELETE_SUCCESS,
  payload: message,
});

export const deleteUserFailure = (error) => ({
  type: actionTypes.USER_DELETE_FAILURE,
  payload: error,
});

export const deleteUserById = (id) => {
  return async (dispatch) => {
    dispatch(deleteUserRequest(id));
    try {
      const response = await api.deleteUser(id);
      dispatch(deleteUserSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteUserFailure(error));
      return { success: false, message: error };
    }
  };
};

export const ResentOtpRequest = (userInputs) => ({
  type: actionTypes.USER_RESENTMAIL_REQUEST,
  payload: userInputs,
});
export const ResentOtpSuccess = (user) => ({
  type: actionTypes.USER_RESENTMAIL_SUCCESS,
  payload: user,
});

export const ResentOtpFailure = (error) => ({
  type: actionTypes.USER_RESENTMAIL_FAILURE,
  payload: error,
});


export const reSentOtp = (userInputs) => {
  return async (dispatch) => {
    dispatch(ResentOtpRequest(userInputs));
    try {
      const response = await api.reSentOtp(userInputs);
      if (response.status === 200) {
        dispatch(ResentOtpSuccess(response.data.user));
        return { success: true };
      } else {
        dispatch(ResentOtpFailure(response.message || 'state input failed'));
        return { success: false, message: response.message };
      }
    } catch (error) {
      dispatch(ResentOtpFailure(error.message || 'An error occurred'));
      return { success: false, message: error.message };
    }
  };
};

export const ResentMailRequest = (userInputs) => ({
  type: actionTypes.USER_RESENTMAIL_REQUEST,
  payload: userInputs,
});
export const ResentMailSuccess = (user) => ({
  type: actionTypes.USER_RESENTMAIL_SUCCESS,
  payload: user,
});

export const ResentMailFailure = (error) => ({
  type: actionTypes.USER_RESENTMAIL_FAILURE,
  payload: error,
});


export const reSentMail = (userInputs) => {
  return async (dispatch) => {
    dispatch(ResentMailRequest(userInputs));
    try {
      const response = await api.reSentMail(userInputs);
      if (response.status === 200) {
        dispatch(ResentMailSuccess(response.data.user));
        return { success: true , message: response.data.message};
      } else {
        dispatch(ResentMailFailure(response.message || 'state input failed'));
        return { success: false, message: response.message };
      }
    } catch (error) {
      dispatch(ResentOtpFailure(error.message || 'An error occurred'));
      return { success: false, message: error.message };
    }
  };
};


export const updateUserPasswordRequest = (userData) => ({
    type: actionTypes.USER_UPDATE_REQUEST,
    payload: { userData },
  });

  export const updateUserPasswordSuccess = (message) => ({
    type: actionTypes.USER_UPDATE_SUCCESS,
    payload: message,
  });

  export const updateUserPasswordFailure = (error) => ({
    type: actionTypes.USER_UPDATE_FAILURE,
    payload: error,
  });

  export const updateUserPassword = (stateData) => {
    return async (dispatch) => {
      const user = JSON.parse(sessionStorage.getItem('user'));
      dispatch(updateUserRequest(stateData));
      try {
        const response = await api.updateUserPassword(stateData);
        dispatch(updateUserSuccess(response.message));
        return { success: true, message: response.message };
      } catch (error) {
        dispatch(updateUserFailure(error));
        return { success: false, message: error };
      }
    };
  };


  
// Action Creators
export const uploadUserProfileRequest = () => ({
  type: actionTypes.USER_PROFILE_UPLOAD_REQUEST,
});

export const uploadUserProfileSuccess = (message) => ({
  type: actionTypes.USER_PROFILE_UPLOAD_SUCCESS,
  payload: message,
});

export const uploadUserProfileFailure = (error) => ({
  type: actionTypes.USER_PROFILE_UPLOAD_FAILURE,
  payload: error,
});

// Thunk for uploading profile image
export const uploadUserProfile = (file) => {
  return async (dispatch) => {
    dispatch(uploadUserProfileRequest());

    try {
      const formData = new FormData();
      formData.append("profile_image", file);

      const response = await api.uploadUserProfile(formData);
      dispatch(uploadUserProfileSuccess(response.message));
      return { success: true, data: response.image_url };
    } catch (error) {
      dispatch(uploadUserProfileFailure(error));
      return { success: false, message: error };
    }
  };
};

export const deleteUserProfileRequest = () => ({
  type: actionTypes.USER_PROFILE_DELETE_REQUEST,
});

export const deleteUserProfileSuccess = (message) => ({
  type: actionTypes.USER_PROFILE_DELETE_SUCCESS,
  payload: message,
});

export const deleteUserProfileFailure = (error) => ({
  type: actionTypes.USER_PROFILE_DELETE_FAILURE,
  payload: error,
});

export const deleteUserProfile = () => {
  return async (dispatch) => {
    dispatch(deleteUserProfileRequest());
    try {
      const response = await api.deleteUserProfile();
      dispatch(deleteUserProfileSuccess(response.message));
      return { success: true };
    } catch (error) {
      dispatch(deleteUserProfileFailure(error));
      return { success: false, message: error };
    }
  };
};


// Fetch profile actions
export const fetchUserProfileRequest = (userId) => ({
  type: actionTypes.USER_PROFILE_FETCH_REQUEST,
});

export const fetchUserProfileSuccess = (profile) => ({
  type: actionTypes.USER_PROFILE_FETCH_SUCCESS,
  payload: profile,
});

export const fetchUserProfileFailure = (error) => ({
  type: actionTypes.USER_PROFILE_FETCH_FAILURE,
  payload: error,
});

// Thunk to fetch profile
export const fetchUserProfiles = () => {
  return async (dispatch) => {
    dispatch(fetchUserProfileRequest());
    try {
      const response = await api.fetchUsersProfiles(); // your api call
      dispatch(fetchUserProfileSuccess(response.profile || null));
    } catch (error) {
      dispatch(fetchUserProfileFailure(error));
    }
  };
};


export const getUserProfileRequest = () => ({
  type: actionTypes.USER_GET_REQUEST,
});

export const getUserProfileSuccess = (user) => ({
  type: actionTypes.USER_GET_PROFILE_SUCCESS,
  payload: user,
});

export const getUserProfileFailure = (error) => ({
  type: actionTypes.USER_GET_PROFILE_FAILURE,
  payload: error,
});

export const getUserProfile = () => {
    return async (dispatch) => {
      dispatch(getUserProfileRequest());
      try {
        const user = await api.fetchUsersProfiles();
        dispatch(getUserProfileSuccess(user));
        return { success: true, data: user };
      } catch (error) {
        dispatch(getUserProfileFailure(error));
        return { success: false, message: error };
      }
    };
  };